import { Button } from '@ds';
import { CountryStatePairFilter } from '@features/components/CountryStatePairFilter';
import { MdOutlineClear } from 'react-icons/md';
import { UseFiltersType } from '@/hooks/useFilters';
import { OpoOrganizationListFilters } from '@/api/apis/opo';

type OPOsFiltersProps = UseFiltersType<Required<OpoOrganizationListFilters>>;

export const OPOsFilters = ({ filters, hasFilters, updateFilters, clearFilters }: OPOsFiltersProps) => {
  return (
    <div className="flex gap-7 items-center">
      <CountryStatePairFilter filters={filters} updateFilters={updateFilters} />
      {hasFilters && (
        <Button startContent={<MdOutlineClear size={18} />} size="sm" variant="light" onClick={clearFilters}>
          Clear all
        </Button>
      )}
    </div>
  );
};
